import type { Example } from '../types';

export const sceneGridExample: Example = {
  id: 'scene-grid',
  title: 'Scene Grid & Background',
  categoryId: 'viewer',
  description: 'Custom grids, print-volume overlay, background tint',
  scadCode: `/* Scene Grid & Background */

// markdown:tip
// **Scene Grid & Background** — Use \`scene_grid()\` to add custom grids
// to the viewport and \`scene_background()\` to tint the background.
// Toggle the print-volume overlay to see a build-plate cube grid.

/* [Grid] */

// Show floor grid?
show_grid = true;

// Grid cell size (mm)
grid_size = 10; // [5:1:30] {show_grid == true}

// Grid color
// color
grid_color = [0.35, 0.35, 0.45];

// Show print volume overlay?
show_volume = false;

// Print bed size (mm)
bed_size = 120; // [80:10:300] {show_volume == true}

/* [Background] */

// Background color
// color
bg_color = [0.08, 0.08, 0.12];

/* [Model] */

// Box width
box_w = 50; // [20:1:100]

// Box depth
box_d = 35; // [20:1:80]

// Box height
box_h = 28; // [10:1:60]

// Body color
// color
box_color = [0.3, 0.55, 0.8];

// --- parameters end ---

// Scene configuration
scene_background(color=bg_color);

if (show_grid)
  scene_grid(type="plane", size=grid_size, color=grid_color);

if (show_volume)
  scene_grid(type="cube", size=bed_size, color=[0.5, 0.7, 0.5]);

// Model — box sitting on the ground plane
color(box_color)
translate([0, 0, box_h / 2])
  cube([box_w, box_d, box_h], center=true);

// Small sphere on top
color([0.9, 0.6, 0.2])
translate([0, 0, box_h + 10])
  sphere(r=10, $fn=48);
`,
};
